import React, { useEffect, useState } from 'react';
import { ArrowLeftIcon, FileTextIcon, PackageIcon, PencilRulerIcon, CheckIcon, PercentIcon, ShieldIcon, TentIcon, DollarSignIcon, SearchIcon, BellIcon, UserIcon, ChevronDownIcon, CalendarIcon, BarChart3Icon, HelpCircleIcon } from 'lucide-react';
import { PivotQuoteFlow } from '../components/quotes/pivot/PivotQuoteFlow';
import { SparePartsQuoteFlow } from '../components/quotes/spareparts/SparePartsQuoteFlow';
import { ProjectQuoteFlow } from '../components/quotes/project/ProjectQuoteFlow';
import { PromoCodeInput } from '../components/quotes/PromoCodeInput';
export function NewQuotePage({
  onBack,
  isEditing = false,
  quoteData = null
}) {
  const [selectedType, setSelectedType] = useState(quoteData?.type?.toLowerCase() || null);
  const [promoCode, setPromoCode] = useState<string | null>(null);
  const [isValidCode, setIsValidCode] = useState(false);
  const [discount, setDiscount] = useState<number | null>(null);
  // Determinar el título según si estamos editando o creando
  const pageTitle = isEditing ? 'Edit Quote' : 'New Quote';
  // Si estamos editando y no hay un tipo seleccionado, pero tenemos datos,
  // intentamos determinar el tipo basado en los datos
  useEffect(() => {
    if (isEditing && quoteData && !selectedType) {
      if (quoteData.pivots) {
        setSelectedType('pivot');
      } else if (quoteData.parts) {
        setSelectedType('spareparts');
      } else if (quoteData.items || quoteData.projectDetails) {
        setSelectedType('project');
      }
    }
  }, [isEditing, quoteData, selectedType]);
  const handleApplyPromoCode = (code: string) => {
    // In a real application, you would validate the code against an API
    // For this example, we'll simulate a valid code for "FERIA2025"
    if (code.toUpperCase() === 'FERIA2025') {
      setPromoCode(code);
      setIsValidCode(true);
      setDiscount(40); // 40% discount
    } else {
      setPromoCode(code);
      setIsValidCode(false);
      setDiscount(null);
    }
  };
  const handleClearPromoCode = () => {
    setPromoCode(null);
    setIsValidCode(false);
    setDiscount(null);
  };
  return <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-9556">
      {/* Header */}
      <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-9557">
        <div className="px-6 py-4 flex justify-between items-center" data-id="element-9558">
          <div className="flex items-center" data-id="element-9559">
            <button onClick={onBack} className="mr-3 text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-9560">
              <ArrowLeftIcon size={20} data-id="element-9561" />
            </button>
            <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-9562">
              <FileTextIcon size={20} className="text-white" data-id="element-9563" />
            </div>
            <div data-id="element-9564">
              <h1 className="text-xl font-bold text-white" data-id="element-9565">{pageTitle}</h1>
              <p className="text-blue-200 text-sm hidden sm:block" data-id="element-9566">
                {isEditing ? `Editing Quote #${quoteData?.id || quoteData?.quoteNumber}` : 'Create a new quote for your customer'}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-9567">
            <div className="relative hidden sm:block" data-id="element-9568">
              <div className="relative" data-id="element-9569">
                <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" data-id="element-9570" />
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-9571" />
              </div>
            </div>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-9572">
              <CalendarIcon size={20} data-id="element-9573" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-9574">
              <BarChart3Icon size={20} data-id="element-9575" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-9576">
              <HelpCircleIcon size={20} data-id="element-9577" />
            </button>
            <div className="relative" data-id="element-9578">
              <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-9579">
                <BellIcon size={20} data-id="element-9580" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-9581">
                  3
                </span>
              </button>
            </div>
            <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-9582">
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-9583">
                <UserIcon size={16} className="text-white" data-id="element-9584" />
              </div>
              <span className="text-white text-sm font-medium hidden sm:block" data-id="element-9585">
                Daniel Alejandro
              </span>
              <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-9586" />
            </div>
            {promoCode && isValidCode && <div className="hidden md:flex items-center bg-amber-600/20 border border-amber-500/30 rounded-lg px-3 py-1.5" data-id="element-9587">
                <PercentIcon size={16} className="text-amber-400 mr-1.5" data-id="element-9588" />
                <span className="text-amber-300 text-sm font-medium" data-id="element-9589">
                  {discount}% discount applied
                </span>
              </div>}
          </div>
        </div>
      </header>
      {/* Main content */}
      <div className="p-6 max-w-7xl mx-auto" data-id="element-9590">
        {!selectedType ? <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-9591">
            {/* Left column - Quote type selection */}
            <div className="lg:col-span-2" data-id="element-9592">
              <div className="bg-slate-800/30 backdrop-blur-sm rounded-xl border border-blue-800/30 p-6 mb-6" data-id="element-9593">
                <div className="flex items-center mb-6" data-id="element-9594">
                  <div className="p-2 bg-blue-900/50 rounded-lg mr-3" data-id="element-9595">
                    <FileTextIcon size={20} className="text-blue-400" data-id="element-9596" />
                  </div>
                  <h2 className="text-xl font-bold text-white" data-id="element-9597">
                    Select quote type
                  </h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-9598">
                  <QuoteTypeCard icon={<PencilRulerIcon size={24} className="text-blue-400" data-id="element-9600" />} title="Pivot Quote" description="Create a quote for center pivot or linear irrigation systems" onClick={() => setSelectedType('pivot')} data-id="element-9599" />
                  <QuoteTypeCard icon={<PackageIcon size={24} className="text-blue-400" data-id="element-9602" />} title="Spare Parts Quote" description="Create a quote for spare parts and components" onClick={() => setSelectedType('spareparts')} data-id="element-9601" />
                  <QuoteTypeCard icon={<FileTextIcon size={24} className="text-blue-400" data-id="element-9604" />} title="Project Quote" description="Create a comprehensive quote for a complete irrigation project" onClick={() => setSelectedType('project')} data-id="element-9603" />
                </div>
              </div>
              {/* Promo code input */}
              <PromoCodeInput onApply={handleApplyPromoCode} onClear={handleClearPromoCode} appliedCode={promoCode} isValid={isValidCode} discount={discount} data-id="element-9605" />
            </div>
            {/* Right column - Benefits and information */}
            <div className="bg-gradient-to-br from-blue-900/30 to-indigo-900/30 backdrop-blur-sm rounded-xl border border-blue-800/30 p-6" data-id="element-9606">
              <div className="flex items-center mb-6" data-id="element-9607">
                <div className="p-2 bg-indigo-900/50 rounded-lg mr-3" data-id="element-9608">
                  <DollarSignIcon size={20} className="text-indigo-400" data-id="element-9609" />
                </div>
                <h2 className="text-xl font-bold text-white" data-id="element-9610">Quote Benefits</h2>
              </div>
              <div className="space-y-5" data-id="element-9611">
                <BenefitItem icon={<CheckIcon size={18} className="text-green-400" data-id="element-9613" />} title="Accurate Pricing" description="Get real-time pricing based on the latest product catalog" data-id="element-9612" />
                <BenefitItem icon={<ShieldIcon size={18} className="text-blue-400" data-id="element-9615" />} title="60-Day Validity" description="All quotes are valid for 60 days from creation" data-id="element-9614" />
                <BenefitItem icon={<PercentIcon size={18} className="text-purple-400" data-id="element-9617" />} title="Volume Discounts" description="Automatic discounts applied for bulk orders" data-id="element-9616" />
                <BenefitItem icon={<TentIcon size={18} className="text-amber-400" data-id="element-9619" />} title="Fair Promotions" description="Use fair codes for exclusive discounts (FERIA2025)" data-id="element-9618" />
              </div>
              {/* Testimonial */}
              <div className="mt-8 bg-white/5 rounded-lg p-4 border border-white/10" data-id="element-9620">
                <p className="text-blue-200 italic text-sm" data-id="element-9621">
                  "The quoting system has streamlined our sales process and
                  increased our conversion rate by 28% in just three months."
                </p>
                <div className="flex items-center mt-3" data-id="element-9622">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center text-white text-xs font-bold" data-id="element-9623">
                    JF
                  </div>
                  <div className="ml-2" data-id="element-9624">
                    <div className="text-white text-sm font-medium" data-id="element-9625">
                      Jose Fernando
                    </div>
                    <div className="text-blue-300 text-xs" data-id="element-9626">
                      CEO, AiscoEurope
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> : selectedType === 'pivot' ? <PivotQuoteFlow initialData={isEditing ? quoteData : null} promoCode={promoCode} discount={isValidCode ? discount : null} data-id="element-9627" /> : selectedType === 'spareparts' ? <SparePartsQuoteFlow initialData={isEditing ? quoteData : null} promoCode={promoCode} discount={isValidCode ? discount : null} data-id="element-9628" /> : <ProjectQuoteFlow initialData={isEditing ? quoteData : null} promoCode={promoCode} discount={isValidCode ? discount : null} data-id="element-9629" />}
      </div>
    </div>;
}
// Helper components
function QuoteTypeCard({
  icon,
  title,
  description,
  onClick
}) {
  return <button onClick={onClick} className="bg-gradient-to-br from-blue-500/10 to-indigo-500/20 hover:from-blue-500/20 hover:to-indigo-500/30 border border-blue-400/30 rounded-xl p-6 text-left transition-all hover:scale-105 hover:shadow-lg group" data-id="element-9630">
      <div className="p-3 bg-blue-600/20 group-hover:bg-blue-600/30 rounded-lg inline-flex mb-4 transition-colors" data-id="element-9631">
        {icon}
      </div>
      <h3 className="text-lg font-bold text-white mb-2" data-id="element-9632">{title}</h3>
      <p className="text-blue-200 text-sm" data-id="element-9633">{description}</p>
    </button>;
}
function BenefitItem({
  icon,
  title,
  description
}) {
  return <div className="flex" data-id="element-9634">
      <div className="mt-0.5 mr-3" data-id="element-9635">{icon}</div>
      <div data-id="element-9636">
        <h3 className="text-white font-medium" data-id="element-9637">{title}</h3>
        <p className="text-blue-300 text-sm mt-0.5" data-id="element-9638">{description}</p>
      </div>
    </div>;
}